import { Group, Stack, Text } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import Badge from 'components/Badge';
import React from 'react';

interface SMEProps {
  name: string;
  type: string;
  subtitle: string;
  linkURL: string;
  noBadge?: boolean;
}

const SMEName = ({ name, type, subtitle, linkURL, noBadge = false }: SMEProps) => {
  const { hovered, ref } = useHover();
  return (
    <Stack gap={0}>
      <Group gap={4} ref={ref}>
        <Text
          fz={'sm'}
          c={hovered ? 'primary' : 'dark'}
          td={hovered ? 'underline' : 'none'}
          fw={700}
          component='a'
          href={linkURL}
          target='_blank'
        >
          {name}
        </Text>
        {!noBadge && (
          <Badge styleVariant='default'>{type === 'internal' ? 'Internal' : 'External'}</Badge>
        )}
      </Group>

      <Text fz={'sm'} fw={500}>
        {subtitle}
      </Text>
    </Stack>
  );
};

export default SMEName;
